import atck from '../components';

const install = function (Vue, opts = {}) {
    Object.keys(atck).forEach((key) => {//收集所有组件
        Vue.component('b' + key, atck[key]);
    });
    // Vue.prototype.$SideModal = SideModal;
};

// auto install
if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
}

export default Object.assign(atck, {install});   // eslint-disable-line no-undef



// WEBPACK FOOTER //
// ./src/commons/index.js